import React from 'react';
import PropTypes from 'prop-types';

import { QuoteLeft } from './../Icons';

const TestimonialCard = ({ author, cite, content, date, link }) => {
  if (!content) {
    return null;
  }

  return (
    <blockquote className='testimonial-card'>
      <div className='testimonial-card__body'>
        <QuoteLeft className='testimonial-card__icon' />
        {content && <div className='testimonial-card__content'>{content}</div>}
        {author && <div className='testimonial-card__author'>— {author}</div>}
      </div>
      <div className='testimonial-card__footer'>
        {cite && link && (
          <a href={link} rel='noreferrer' target='_blank' className='testimonial-card__cite'>
            {cite}
          </a>
        )}
        {cite && !link && <div className='testimonial-card__cite'>{cite}</div>}
        {date && <div className='testimonial-card__date'>{date}</div>}
      </div>
    </blockquote>
  );
};

TestimonialCard.propTypes = {
  author: PropTypes.string,
  cite: PropTypes.string,
  content: PropTypes.string,
  date: PropTypes.string,
  link: PropTypes.string,
};

export default TestimonialCard;
